import { styled, keyframes } from "leva/plugin";

export const Svg = styled("svg", {
	width: "100%",
	height: "100%",
	position: "absolute",
	top: 0,
	left: 0,
	// marginTop: '12px',
	overflow: "visible",
	userSelect: "none",
	zIndex: 100,
	"> path": {
		stroke: "$highlight3",
		strokeWidth: 2,
	},
	g: {
		color: "$accent1",
		"&:hover": { color: "$accent3" },
		"&:active": { color: "$vivid1" },
	},
	circle: {
		fill: "currentColor",
		strokeWidth: 10,
		stroke: "transparent",
		cursor: "pointer",
	},
	"> line": {
		stroke: "$highlight1",
		strokeWidth: 1,
	},
	"> g > line": {
		stroke: "currentColor",
	},
	variants: {
		withPreview: {
			true: { marginBottom: 0 },
			false: { marginBottom: "$rowGap" },
		},
	},
});

export const SmallSvg = styled("svg", {
	width: "35px",
	height: "35px",
	// marginTop: '$rowGap',
	overflow: "visible",
	userSelect: "none",
	zIndex: 100,
	"> path": {
		stroke: "$highlight3",
		strokeWidth: 1,
	},
	g: {
		color: "$accent1",
		"&:hover": { color: "$accent3" },
		"&:active": { color: "$vivid1" },
	},
	"> line": {
		stroke: "$highlight1",
		strokeWidth: 1,
	},
	"> g > line": {
		stroke: "currentColor",
	},
	variants: {
		withPreview: {
			true: { marginBottom: 0 },
			false: { marginBottom: "2px" },
		},
	},
});

const fadeIn = (o: number) =>
	keyframes({
		"0%": { opacity: 0 },
		"10%": { opacity: 0.8 },
		"100%": { opacity: o },
	});

const move = keyframes({
	"0%": { transform: "translateX(5%)" },
	"100%": { transform: "translateX(95%)" },
});

export const PreviewSvg = styled("svg", {
	width: "100%",
	overflow: "clip",
	height: 6,
	"> circle": {
		fill: "$accent2",
		cy: "50%",
		animation: `${fadeIn(0.3)} 1000ms both`,
		"&:first-of-type": { animationName: fadeIn(0.7) },
		"&:last-of-type": { animationName: move },
	},
});

export const StyledInnerLabel = styled("div", {
	userSelect: "none",
	$flexCenter: "",
	height: 14,
	width: 14,
	borderRadius: 7,
	marginRight: "$sm",
	cursor: "pointer",
	fontSize: "0.8em",
	variants: {
		graph: { true: { backgroundColor: "$elevation1" } },
	},
});

export const Container = styled("div", {
	display: "grid",
	gridTemplateColumns: "auto 1fr",
	alignItems: "center",
});

//styling a leva "Row" component
export const StyledToolBottomRow = {
	gridTemplateColumns: "50% 15% 15%  auto",
	padding: "8px 0 10px 0",
};
